import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css']
})
export class PaginationComponent {

  @Output() paginateEvent = new EventEmitter<string>();
  
  constructor(){
  }

  handlePageChange(event: any) {
    this.paginateEvent.emit(event);
  }

}
